module.exports = __webpack_public_path__ + "static/media/match.c2231323.png";